import React, {useEffect, useMemo, useState} from 'react';
import {ProfileUserProps} from "./ProfileUser.props";
import {checkManagerTabs} from "../../utils/util";
import {TabsHeader} from "../../components/TabsHeader";
import {useLocation, useNavigate} from "react-router-dom";
import MyDashBoard from "../MyDashBoard/MyDashBoard";
import {LeaderboardContainer} from "../../components/Leaderboard/LeaderboardContainer";
import {useAppSelector} from "../../redux/hooks";
import {workSpaceEventsDataSelector} from "../../redux/workSpaceSlice";
import {useMediaQuery, useTheme} from "@mui/material";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";

const ProfileUserComponent: React.FC<ProfileUserProps> = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState<number>(0);
  const {workSpaceCurrentData, isLoading} = useAppSelector(workSpaceEventsDataSelector);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

  const isHideAllMetricTabsLeaderboard = useMemo(
    () =>
      !workSpaceCurrentData?.show_email_reporting_data &&
      !workSpaceCurrentData?.show_training_completion_data &&
      !workSpaceCurrentData?.show_achievement_collection_data,
    [workSpaceCurrentData]
  );
  
  const dataTabs: any =
    !isLoading && workSpaceCurrentData ? [
      {
        label: 'My Dashboard',
        component: <MyDashBoard/>,
        hidden: !workSpaceCurrentData?.enable_my_dashboard
      },
      {
        label: 'Organisation Leaderboard',
        component: <LeaderboardContainer cellId={workSpaceCurrentData?.cell_id ?? 0}/>,
         hidden:
              !workSpaceCurrentData?.enable_leaderboard ||
              !workSpaceCurrentData.cell_id ||
              isHideAllMetricTabsLeaderboard
      },
    ] : [];

  useEffect(() => {
    if (state !== null) {
      setTabIndex(state.tabIndex);
    }
  }, [state]);
  const handleTabClick = (val: any) => {
    navigate('/profile', {
      state: {
        tabIndex: val,
      }
    });
  };

  return (
    <>
      {workSpaceCurrentData ? <TabsHeader
        {...checkManagerTabs(dataTabs, tabIndex)}
        key={'profile-user'}
        onClick={handleTabClick}
        isDropdown={isMobile}
      /> : null}
    </>
  );
};

export const ProfileUser = ChangeWorkSpace(ProfileUserComponent);